import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import moment from 'moment';
import { noop } from 'lodash';
import withFocusedState from "../../../enhancers/withFocusedState";
import ReactDatepicker from '../ReactDatepicker';
import "./DateField.css";

var DateField =
/** @class */
function (_super) {
  tslib_1.__extends(DateField, _super);

  function DateField() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.inputRef = null;

    _this.setInputRef = function (input) {
      _this.inputRef = input;
    };

    _this.parseDate = function (value) {
      var _a = _this.props,
          format = _a.format,
          strict = _a.strict;
      if (value instanceof Date) return value;
      var date = moment(value, format, strict);
      return date.isValid() ? date.toDate() : null;
    };

    _this.handleChange = function (selected) {
      _this.props.onChange(selected);
    };

    _this.handleBlur = function (event) {
      // Input value parsing has been failed
      if (_this.inputRef && _this.inputRef.state.inputValue) {
        var initialDate = _this.parseDate(_this.props.value);

        _this.inputRef.setSelected(initialDate, event, false);
      }

      _this.props.onBlur(event);
    };

    return _this;
  }

  DateField.prototype.render = function () {
    var _a, _b;

    var _c = this.props,
        kind = _c.kind,
        tip = _c.tip,
        blockName = _c.blockName,
        className = _c.className,
        inputClassName = _c.inputClassName,
        calendarClassName = _c.calendarClassName,
        tipClassName = _c.tipClassName,
        value = _c.value,
        start = _c.start,
        end = _c.end,
        displayFormat = _c.displayFormat,
        focused = _c.focused,
        disabled = _c.disabled,
        isError = _c.isError,
        inputId = _c.inputId,
        positionFixed = _c.positionFixed,
        popperProps = _c.popperProps,
        other = tslib_1.__rest(_c, ["kind", "tip", "blockName", "className", "inputClassName", "calendarClassName", "tipClassName", "value", "start", "end", "displayFormat", "focused", "disabled", "isError", "inputId", "positionFixed", "popperProps"]);

    var finalClassName = cx(blockName, (_a = {}, _a[blockName + "--" + kind] = kind, _a[blockName + "--disabled"] = disabled, _a[blockName + "--active"] = focused, _a[blockName + "--error"] = isError, _a[blockName + "--disabled-error"] = isError && disabled, _a[blockName + "--active-error"] = isError && focused, _a), className);
    var tipFinalClassName = cx(blockName + "__tip", tipClassName, (_b = {}, _b[blockName + "__tip--error"] = isError, _b));
    var extraProps = {};

    if (start || end) {
      if (value === start) {
        extraProps.selectsStart = true;
      } else if (value === end) {
        extraProps.selectsEnd = true;
      }
    }

    var finalPopperProps = tslib_1.__assign({
      positionFixed: positionFixed
    }, popperProps);

    return React.createElement("div", {
      className: finalClassName
    }, React.createElement(ReactDatepicker, tslib_1.__assign({}, other, extraProps, {
      className: cx(blockName + "__input", inputClassName),
      calendarClassName: cx(blockName + "__calendar", calendarClassName),
      selected: value && this.parseDate(value),
      startDate: start && this.parseDate(start),
      endDate: end && this.parseDate(end),
      dateFormat: displayFormat,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      disabled: disabled,
      id: inputId,
      ref: this.setInputRef,
      fixedHeight: true,
      popperProps: finalPopperProps
    })), !!tip && React.createElement("span", {
      className: tipFinalClassName
    }, tip));
  };

  DateField.propTypes = {
    /** Available options: `default` (h=32px) and `narrow` (h=24px). */
    kind: PropTypes.string,
    tip: PropTypes.string,
    inputId: PropTypes.string,
    blockName: PropTypes.string,
    className: PropTypes.string,
    inputClassName: PropTypes.string,
    calendarClassName: PropTypes.string,
    tipClassName: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),

    /** Start date for range. */
    start: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),

    /** End date for range. */
    end: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),

    /** Date format to use to display inside the input field */
    displayFormat: PropTypes.string,
    format: PropTypes.string,

    /** Strictly follow the date format provided. */
    strict: PropTypes.bool,
    focused: PropTypes.bool,
    disabled: PropTypes.bool,
    isError: PropTypes.bool,
    isClearable: PropTypes.bool,
    clearButtonTitle: PropTypes.string,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    positionFixed: PropTypes.bool,
    popperProps: PropTypes.object
  };
  DateField.defaultProps = {
    kind: 'default',
    blockName: 'nx-datefield',
    format: 'MM/DD/YYYY',
    strict: false,
    focused: false,
    disabled: false,
    isError: false,
    isClearable: false,
    clearButtonTitle: 'Clear',
    onChange: noop,
    onFocus: noop,
    onBlur: noop,
    positionFixed: false
  };
  return DateField;
}(Component);

export default withFocusedState(DateField);

try {
  // @ts-ignore
  DateField.__docgenInfo = {
    "description": "",
    "displayName": "DateField",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}